// SPDX-FileCopyrightText: 2026 Mads Ringblom
//
// SPDX-License-Identifier: GPL-3.0-or-later

import { useId, type ReactNode } from 'react';

import styles from './Inspector.module.css';

/** A titled group of field rows (v8 `.fgp`): a run of one category's keys (Materiale, Miljø, …), or Til rapporten. */
export function FieldGroup({ title, children }: { title: string; children: ReactNode }) {
  const id = useId();
  return (
    <section className={styles.group} aria-labelledby={id}>
      <h3 className={styles.groupTitle} id={id}>
        {title}
      </h3>
      {children}
    </section>
  );
}
